import React from "react";
import { ModalProvider } from "../../components/modal-container";
import { useAppContext } from "../../app/AppRootProviders";
import LogoutDialog from "./LogoutDialog";

interface GlobalLayoutProps {
  children: React.ReactNode;
}

const GlobalLayout: React.FC<GlobalLayoutProps> = ({ children }) => {
  const { showLogoutDialog, setShowLogoutDialog, onLogout } = useAppContext();

  return (
    <ModalProvider>
      {children}
      <LogoutDialog
        showLogoutDialog={showLogoutDialog}
        setShowLogoutDialog={setShowLogoutDialog}
        onLogout={onLogout}
      />
    </ModalProvider>
  );
};

export default GlobalLayout;
